import store from '@/store'

export default (to, from, next) => {
    // Fetch the travel eSIM flag BEFORE evaluating access. Reading the getter
    // synchronously would use its default (false) because the remote config
    // hasn't been fetched yet — making access depend on timing instead of the
    // flag. Await the fetch so the page is gated purely by the flag value.
    return store.dispatch('get_is_travel_esim_enabled').catch(() => {}).then(() => ({
        allow: store.getters.is_order_placement_allowed || store.getters.is_travel_esim_enabled,
        redirect: store.getters.is_sign_up_allowed ? { name: 'sign-up' } : { name: 'sign-in' },
    }))
}